import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../Slider.module.css';

const SlideContent = ({ item, isLoaded }) => {
  const navigate = useNavigate();

  const handleProductClick = () => {
    navigate(`/products?category=${item.category}`);
  };

  const handleDemoClick = () => {
    navigate('/contact');
  };

  return (
    <div className={`${styles.content} ${isLoaded ? styles.loaded : ''}`}>
      <div className={styles.textContent}>
        <h2 className={styles.title}>{item.name}</h2>
        <p className={styles.description}>{item.description}</p>
      </div>
      <div className={styles.buttonGroup}>
        <button 
          className={`${styles.button} ${styles.primaryButton}`}
          onClick={handleProductClick}
        >
          Ürünlerİ İncele
        </button>
        <button 
          className={`${styles.button} ${styles.secondaryButton}`}
          onClick={handleDemoClick}
        >
          Demo Talep Et
        </button>
      </div>
    </div>
  );
};

export default SlideContent; 